/**
 * @generated SignedSource<<e1c3670e060bde290cf3f92faac6ea4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignupClientCompletePhotoScreen_user$data = {
  readonly id: string;
  readonly photoURL: string | null | undefined;
  readonly " $fragmentType": "SignupClientCompletePhotoScreen_user";
};
export type SignupClientCompletePhotoScreen_user$key = {
  readonly " $data"?: SignupClientCompletePhotoScreen_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignupClientCompletePhotoScreen_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignupClientCompletePhotoScreen_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photoURL",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8116784c8ac48a655c0d45054b93dbe2";

export default node;
